import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import { Table } from "reactstrap";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import { Form, Formik, Field } from "formik";
import RadioButton from "web/components/form-elements/RadioButton";
import states from "states-us";
import Spinner from "web/components/Spinner";
import { editProfile, certificateList, taxExemptionApi, deleteTaxExemptionApi, taxExemptFileDownload } from "redux/actions/profile";
import { manageAccSellerBussPrefUpdate } from 'redux/actions/postLoad'
import EditTaxExemption from "../EditTaxExemption/index";
import { imageDisplay } from "redux/actions/myClaims";
import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import TextInput from "web/components/form-elements/TextInput";
import Select from "web/components/form-elements/Select";
import { getInitialValues } from "web/components/utils/profileOfficeHourUtils";
import DownloadIcon from "web/assets/svg/DownloadIcon";
import AlertModal from "web/components/AlertModal";
import styles from "./officeHours.module.scss";
import GetCetModal from "web/components/GetCetModal";
import styled from "styled-components";
import Edit from "web/assets/images/edit.png";
import { setCurrentLanguage, fetchLanguageContentNew } from "redux/actions/language";
import { SellerBusinessPrefWrapper } from '../manageAccountStyled'
import { preferencesDownArr, sellingUsersEnums, sellerBusinessCategories, sellerBussPrefPalletTypeList, sellerBussPrefPalletSizeList, sellerBussPrefSpecialServicesList } from '../Constants'

const OfficeHours = ({ pageData, callBackFun, updateButtonDisableState, updateButtonDisableStateToggle }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const authId = localStorage.getItem("authId");
  const token = localStorage.getItem("token");
  const accountType = localStorage.getItem("accountType");
  const currentLocalization = localStorage.getItem("currentLocalization");
  const formType = localStorage.getItem("formType");
  const isCentralized = localStorage.getItem("isCentralizedPaymentMethod");
  const [imageArrState, setImageArrState] = useState();
  const [alertTypeState, setAlertTypeState] = useState("taxExamption");
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  let fileArr = [];
  const [sellerBussPrefEditToggle, setSellerBussPrefEditToggle] = useState(true)
  const [tabledata, setTableData] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = "";
  const [genCetModal, setGenCetModal] = useState(false);
  const genCetToggleModal = () => setGenCetModal(!genCetModal);

  const [editTaxExemptionModal, setEditTaxExemptionModal] = useState(false);
  const toggleEditTaxExemptionModal = () => setEditTaxExemptionModal(!editTaxExemptionModal);
  const [ignoreAddress, setIgnoreAddress] = useState(false);

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  const [genCetListResponse, setGenCetListResponse] = useState(undefined);

  useEffect(() => {
    dispatch(fetchLanguageContentNew(currentLocalization));
    dispatch(setCurrentLanguage(currentLocalization));
  }, [currentLanguage]);

  useEffect(() => {
    if (languageContentNew?.H8_Nav_Profile_Page) setPageLanguageContents(languageContentNew.H8_Nav_Profile_Page);
  }, [languageContentNew]);

  useEffect(() => {
    getCertTableDataAPI();
  }, []);

  const getCertTableDataAPI = async () => {
    let response = await dispatch(certificateList(token, authId));
    setGenCetListResponse(response.value);
  };

  const territoryStates = states.filter((x) => x.contiguous);
  let stateArr = [];
  for (let i = 0; i < territoryStates.length; i++) {
    if (territoryStates[i].name !== 'District Of Columbia') {
      let obj = {
        value: territoryStates[i].name,
        label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
        isoCode: territoryStates[i].abbreviation,
      };
      stateArr.push(obj);
    }
  }

  let officeDaysArr = [
    pageLanguageContents?.Tax_Exemption[10]?.Day_B1,
    pageLanguageContents?.Tax_Exemption[11]?.Day_B2,
    pageLanguageContents?.Tax_Exemption[12]?.Day_B3,
    pageLanguageContents?.Tax_Exemption[13]?.Day_B4,
    pageLanguageContents?.Tax_Exemption[14]?.Day_B5,
    pageLanguageContents?.Tax_Exemption[15]?.Day_B6,
    pageLanguageContents?.Tax_Exemption[16]?.Day_B7,
  ];

  const timmingHours = (props, setFieldValue) => {
    return (
      <DateTimeWrapper className={`${styles.dateAndTime} row`}>
        <div className="col-md-4 col-5">
          <TimePickerInput
            name="deliveryWindowBegin"
            type="time"
            disabled={!updateButtonDisableState}
            selectedValue={props.values?.deliveryWindowBegin}
            showErrorMessages={true}
            onChangeHandler={(time) => {
              if (time === "00:00") {
                setFieldValue("deliveryWindowBegin", "")
              }
            }}
          />
        </div>
        <span className={styles.toStyle}>
          {pageLanguageContents?.Tax_Exemption[9]?.To}
        </span>
        <div className="col-md-4 col-5">
          <TimePickerInput
            name="deliveryWindowEnd"
            type="time"
            disabled={!updateButtonDisableState}
            selectedValue={props.values?.deliveryWindowEnd}
            showErrorMessages={true}
            onChangeHandler={(time) => {
              if (time === "00:00") {
                setFieldValue("deliveryWindowBegin", "")
              }
            }}
          />
        </div>
      </DateTimeWrapper>
    );
  };

  const updateProfile = async (props) => {
    let milesVal = props.values.marketPlace;

    let deliveryWindowBegin = props.values.deliveryWindowBegin;
    let deliveryWindowEnd = props.values.deliveryWindowEnd;
    let deliveryWindowBeginArr = props.values.deliveryWindowBegin.split(":");
    if (deliveryWindowBeginArr.length && deliveryWindowBeginArr[1]) {
      let setHours = deliveryWindowBeginArr[0];
      let setMinutes = deliveryWindowBeginArr[1];
      if (deliveryWindowBeginArr[0].length === 1) {
        setHours = 0 + deliveryWindowBeginArr[0];
      }
      if (deliveryWindowBeginArr[1].length === 1) {
        setMinutes = 0 + deliveryWindowBeginArr[1];
      }
      deliveryWindowBegin = setHours + ":" + setMinutes;
    }
    let deliveryWindowEndArr = props.values.deliveryWindowEnd.split(":");

    if (deliveryWindowEndArr.length && deliveryWindowEndArr[1]) {
      let setHours = deliveryWindowEndArr[0];
      let setMinutes = deliveryWindowEndArr[1];
      if (deliveryWindowEndArr[0].length === 1) {
        setHours = 0 + deliveryWindowEndArr[0];
      }
      if (deliveryWindowEndArr[1].length === 1) {
        setMinutes = 0 + deliveryWindowEndArr[1];
      }
      deliveryWindowEnd = setHours + ":" + setMinutes;
    }
    if (deliveryWindowBegin === "00:00" || deliveryWindowEnd === "00:00") {
      setModalContent("Preference window time is invalid.");
      setModalLink("");
      setAlertTypeState("failure");
      toggleModal();
      return
    }
    const fromTimeValue = parseInt(deliveryWindowBegin?.replace(":", ""));
    const toTimeValue = parseInt(deliveryWindowEnd?.replace(":", ""));
    if ((accountType === 'Both' || accountType === 'Seller') && toTimeValue <= fromTimeValue) {
      setModalContent("Preference window time is invalid.");
      setModalLink("");
      setAlertTypeState("failure");
      toggleModal();
      return
    }

    let officeDays = [];

    let valArr = [props.values.day0, props.values.day1, props.values.day2, props.values.day3, props.values.day4, props.values.day5, props.values.day6,];

    for (let i = 0; i < officeDaysArr.length; i++) {
      if (valArr[i] === true) officeDays.push(officeDaysArr[i])
    }
    if (officeDays.length <= 0) {
      setModalContent("Please select preferred days.");
      setModalLink("");
      setAlertTypeState("failure");
      toggleModal();
      return
    }
    let officeHoursProps = {
      officeHourStart: deliveryWindowBegin,
      officeHourEnd: deliveryWindowEnd,
      dayOfWeeks: officeDays,
      milesVal: props.values.marketPlace
    }
    callBackFun(officeHoursProps);
  };

  const [tooltipOpenOne, setTooltipOpenOne] = useState(false);
  const iIcon = (infoTxt) => {
    return (
      <>
        <img
          id="TooltipOne"
          src={information}
          style={{
            paddingLeft: "5px",
            position: "relative",
            top: "-1px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltipOpenOne}
          target="TooltipOne"
          toggle={() => setTooltipOpenOne(!tooltipOpenOne)}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };
  const uploadImageTaxExemption = async (props, type, data) => {
    let taxExemptionExpireDate, stateTaxExemption;

    if (type === "addTaxExemption") {
      if (!props.values.taxExemptionExpireDate) {
        taxExemptionExpireDate = pageData.userDetails.taxExemptionExpireDate;
      } else {
        taxExemptionExpireDate = moment(
          props.values.taxExemptionExpireDate
        ).format(BIDFORMAT);
      }
      stateTaxExemption = props.values.stateTaxExemption;
    } else {
      taxExemptionExpireDate = moment(
        props.values.editTaxExemptionExpireDate
      ).format(BIDFORMAT);
      stateTaxExemption = props.values.editStateTaxExemption;
    }

    let imageVal = imageArrState;
    if (pageData.userDetails?.taxExemption && !imageArrState) {
      imageVal = "";
    }
    let formData = new FormData();

    if (type === "editTaxExemption" && !imageArrState) {
      imageVal = data.fileName;
    }
    if (!imageVal && type === "addTaxExemption") {
      setModalContent("Please upload a tax exemption form.");
      setAlertTypeState("taxExamptionFailure");
      setModalLink("");
      toggleModal();
    } else {
      let obj = {
        state: stateTaxExemption,
        taxExemption: imageVal,
        taxExemptionExpireDate: taxExemptionExpireDate,
      };
      const propsData = obj;
      for (let prop in propsData) {
        formData.append(prop, propsData[prop]);
      }
      let taxResponse = await dispatch(taxExemptionApi(formData, token));
      if (taxResponse.status === "SUCCESS") {
        setAlertTypeState("taxExamption");
        setModalContent("Tax exempt form has been successfully updated.");
        setModalLink("");
        toggleModal();
      } else {
        setModalContent(taxResponse.message);
        setAlertTypeState("taxExamptionFailure");
        setModalLink("");
        toggleModal();
      }
    }
  };

  const downloadTaxForm = async (genCetId) => {
    const urlPath = "/order/tax/download_certificate?id=" + authId + "&c_id=" + genCetId;
    let response = await dispatch(taxExemptFileDownload(token, urlPath));

    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "taxExemptForm.pdf");
    document.body.appendChild(link);
    link.click();
  };

  const deleteTaxExemption = async (state) => {
    let response = await dispatch(deleteTaxExemptionApi(state, token));
    if (response.status === "SUCCESS") {
      setAlertTypeState("taxExamption");
      setModalContent(response.message);
      setModalLink("");
      toggleModal();
    } else {
      setModalContent(response.message);
      setAlertTypeState("taxExamptionFailure");
      setModalLink("");
      toggleModal();
    }
  };

  let dependentFlag = false;
  if (
    localStorage.getItem("handlePayment") === "true" &&
    localStorage.getItem("location") === "MAIN" &&
    formType !== "CORPORATE_SUBACC" &&
    isCentralized === "false"
  ) {
    dependentFlag = true;
  }
  if (
    localStorage.getItem("handlePayment") === "false" &&
    localStorage.getItem("location") === "SUBSIDIARY" &&
    formType === "CORPORATE_SUBACC"
  ) {
    dependentFlag = true;
  }
  if (
    localStorage.getItem("handlePayment") === null &&
    localStorage.getItem("location") === "SUBSIDIARY" &&
    formType === "CORPORATE_SUBACC" &&
    isCentralized === "false"
  ) {
    dependentFlag = true;
  }

  const sellerBussPrefUpdateFunction = async (props) => {
    let formikData = props.values
    let data = {
      authId: localStorage.getItem('authId'),
      businessCategory: formikData?.sellerBusinessCategory !== '' ? formikData?.sellerBusinessCategory : null,
      typeOfPallets: formikData?.sellerBussPrefPalletType,
      palletSize: formikData?.sellerBussPrefPalletSize,
      specializedService: formikData?.sellerBussPrefSpecialServices
    }
    let response = await dispatch(manageAccSellerBussPrefUpdate(data, token));
    if (response.success) {
      setSellerBussPrefEditToggle(true)
      setAlertTypeState("");
      setModalContent(response.data?.msg);
      setModalLink("");
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response.data?.error?.message || 'Something went wrong, please try again in sometime.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  return (
    <>
      {loaderVisible && <Spinner />}
      {pageData && (
        <Formik
          initialValues={getInitialValues(pageData)}
          onSubmit={(values) => { }}
        >
          {(props) => {
            const { isValid, dirty, values, errors, touched, setFieldValue } = props;
            return (
              <>
                <Form>
                  <div>
                    {(pageData?.userDetails?.userRole !== 'GUEST' && pageData?.userDetails?.userRole !== 'BUYER') && (
                      <div className=" mb-3 ">
                        <div className="col-sm-12 p-0">
                          <label className="form-label">
                            {pageLanguageContents?.Tax_Exemption[7]?.Hours}
                          </label>
                          <div
                            className={`${styles.subHeading} ${styles.bdrBtm} w-100`}
                          >
                            {timmingHours(props, setFieldValue)}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row mt-4">
                      <>
                        <OfficeUpdateBtn>
                          <div
                            className={styles.editUpdate}
                            style={{ cursor: "pointer" }}
                          >
                            {updateButtonDisableState ? (
                              <p
                                className={styles.edit}
                                onClick={(e) => updateProfile(props)}
                              >
                                Update
                              </p>
                            ) : (
                              <p onClick={(e) => updateButtonDisableStateToggle(true)}                            >
                                Edit
                                <img
                                  src={Edit}
                                  alt="Edit"
                                  style={{ width: "25px", marginleft: "10px" }}
                                  onClick={(e) => {
                                    updateButtonDisableStateToggle(true);
                                  }}
                                ></img>
                              </p>
                            )}
                          </div>
                        </OfficeUpdateBtn>
                        <div className="col-sm-12">
                          <label className="form-label">
                            {pageLanguageContents?.Tax_Exemption[8]?.Day}
                          </label>
                          <div
                            className={`${styles.subHeading} ${styles.bdrBtm} ${styles.daysCheckBox} mt-0 office-days`}
                          >
                            {officeDaysArr.map((value, i) => (
                              <CheckboxInput
                                name={"day" + i}
                                label={officeDaysArr[i]}
                                disabled={!updateButtonDisableState}
                                handleSelect={(e) => { }}
                              />
                            ))}
                          </div>
                        </div>
                      </>

                      <div className="col-sm-6">
                        <div className="my-2 text-left">
                          <p>
                            Company Preference
                          </p>
                        </div>
                        <div className="app-input-text">
                          <Select
                            name="marketPlace"
                            data={preferencesDownArr}
                            disabled={!updateButtonDisableState}
                            placeholder={"Miles radius from location"}
                            searchable={true}
                            onChangeHandler={(data) => {
                              setFieldValue("milesInput", "");
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {sellingUsersEnums?.includes(pageData?.userDetails?.userRole) &&
                      <SellerBusinessPrefWrapper>
                        <span className="separator-line"></span>
                        <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between' }}>
                          <h6>Tell Us About Yourself!</h6>
                          <OfficeUpdateBtn style={{ top: '0px' }}>
                            <div className={styles.editUpdate} style={{ cursor: "pointer" }}>
                              {!sellerBussPrefEditToggle ? (
                                <p style={{ margin: 0 }} className={styles.edit} onClick={(e) => sellerBussPrefUpdateFunction(props)}>Update</p>
                              ) : (
                                <p style={{ margin: 0 }}>
                                  Edit
                                  <img
                                    src={Edit}
                                    alt="Edit"
                                    style={{ width: "25px", marginleft: "10px" }}
                                    onClick={(e) => setSellerBussPrefEditToggle(false)}
                                  ></img>
                                </p>
                              )}
                            </div>
                          </OfficeUpdateBtn>
                        </div>
                        <p className="header-pTag-style">Sellers: How would you best categorize your business?</p>
                        <div className={`seller-buss-cat-style ${sellerBussPrefEditToggle ? "radio-check-disable-class" : ""}`}>
                          {sellerBusinessCategories?.map((value, index) => (
                            <div key={index}>
                              <Field
                                component={RadioButton}
                                name="sellerBusinessCategory"
                                id={value.value}
                                defaultValue={sellerBusinessCategories[0].value}
                                onSelect={(e) => { }}
                                label={value.label}
                                disabled={sellerBussPrefEditToggle}
                              />
                            </div>
                          ))}
                        </div>
                        <p className="header-pTag-style">Sellers: What does your company specialize in? It will help to tailor new opportunities to you!</p>
                        <div className="type-wrapper">
                          <p>Sellers: What type of pallets do you sell?</p>
                          <div className='type-checkbox-style'>
                            {sellerBussPrefPalletTypeList.map((data, i) => (
                              <CheckboxInput
                                name={data.value}
                                label={data.label}
                                disabled={sellerBussPrefEditToggle}
                                handleSelect={(name, label, checked, value) => {
                                  let tempValue = values?.sellerBussPrefPalletType?.filter(data => data !== value)
                                  if (checked) tempValue.push(value)
                                  setFieldValue('sellerBussPrefPalletType', tempValue)
                                }}
                                checked={values?.sellerBussPrefPalletType?.includes(data.value) ? true : false}
                              />
                            ))}
                          </div>
                        </div>
                        <hr />
                        <div className="size-wrapper">
                          <p>Sellers: What size of pallets do you sell?</p>
                          <div className='size-checkbox-style'>
                            {sellerBussPrefPalletSizeList.map((data, i) => (
                              <CheckboxInput
                                name={data.value}
                                label={data.label}
                                disabled={sellerBussPrefEditToggle}
                                handleSelect={(name, label, checked, value) => {
                                  let tempValue = values?.sellerBussPrefPalletSize?.filter(data => data !== value)
                                  if (checked) tempValue.push(value)
                                  setFieldValue('sellerBussPrefPalletSize', tempValue)
                                }}
                                checked={values?.sellerBussPrefPalletSize?.includes(data.value) ? true : false}
                              />
                            ))}
                          </div>
                        </div>
                        <hr />
                        <div className="specialServices-wrapper">
                          <p>Sellers: What specialized services do you offer?</p>
                          <div className='specialServices-checkbox-style'>
                            {sellerBussPrefSpecialServicesList.map((data, i) => (
                              <CheckboxInput
                                name={data.value}
                                label={data.label}
                                disabled={sellerBussPrefEditToggle}
                                handleSelect={(name, label, checked, value) => {
                                  let tempValue = values?.sellerBussPrefSpecialServices?.filter(data => data !== value)
                                  if (checked) tempValue.push(value)
                                  setFieldValue('sellerBussPrefSpecialServices', tempValue)
                                }}
                                checked={values?.sellerBussPrefSpecialServices?.includes(data.value) ? true : false}
                              />
                            ))}
                          </div>
                        </div>
                      </SellerBusinessPrefWrapper>
                    }
                  </div>
                </Form>

                {pageLanguageContents && (
                  <EditTaxExemption
                    isOpenTaxExm={editTaxExemptionModal}
                    toggleTaxExm={toggleEditTaxExemptionModal}
                    fileArr={fileArr}
                    pageLanguageContents={pageLanguageContents}
                    imageArrState={imageArrState}
                    tabledata={tabledata}
                    uploadDocument={(imageArr) => {
                      setImageArrState(imageArr);
                    }}
                    updateCallBack={(props, imageArr) => {
                      uploadImageTaxExemption(props, "editTaxExemption", tabledata);
                    }}
                  />
                )}

                {genCetModal && (
                  <GetCetModal
                    isOpen={genCetModal}
                    toggle={genCetToggleModal}
                    title={""}
                    selectedState={props.values?.stateTaxExemption}
                    onClickHander={(val) => {
                      genCetToggleModal();
                    }}
                    callBack={() => {
                      getCertTableDataAPI();
                      genCetToggleModal();
                    }}
                    content={""}
                    link={""}
                  />
                )}

              </>
            );
          }}
        </Formik>
      )}

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        alertType={alertTypeState}
        link={modalLink}
        callBackAlert={(val) => {
          if (val !== "failure") {
            window.location.reload();
          }
        }}
      />
    </>
  );
};

export default OfficeHours;

const Container = styled.div`
  max-width: 1411px;
  padding: 15px 98px;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding: 15px;
  }
`;
const DateTimeWrapper = styled.div`
  .custom-date-piker {
    display: block;
    .app-input-text {
      margin-bottom: 0;
    }
  }
`;
const OfficeUpdateBtn = styled.div`
  position: absolute;
  top: 12px;
  right: 0;
  z-index: 2;
  button {
    width: 167px;
  }
  @media (max-width: 500px) {
    top: 42px;
  }
`;
const UploadOfficeUpdateBtn = styled.div`
  button {
    width: 167px;
  }
`;

const TaxExemption = styled.div`
  /* margin: 25px 0; */
  .error-message-multiple {
    position: unset;
    white-space: normal;
  }
  .uploadPhoto {
    > div {
      margin: 12px auto !important;
      justify-content: space-between;
    }
  }
  .multiple-file-input {
    margin: 0;
    .custom-file-input {
      max-width: 100%;
    }
    .text {
      width: 100%;
    }
    @media (max-width: 575px) {
      .uploadPhoto {
        justify-content: flex-end;
        > div {
          max-width: 266px;
        }
      }
    }
  }
`;
const UploadFileName = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const DataRow = styled.div`
  /* border: 2px dotted #dee2e6 !important; */
  padding: 0 15px;
  overflow: auto;
  .download-btn {
    border: none;
    background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
    border-radius: 5px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 28px;
  }
  .table-responsive {
    max-height: 330px;
    thead {
      position: sticky;
      top: 0;
      background: #fff;
      width: 100%;
    }
  }
  .table thead tr th {
  }
  .table thead tr th.last-child {
    width: 108px;
  }
  .table tbody th {
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #191819;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* width: 100%; */
    max-width: 240px;
    .edit-btn {
      cursor: pointer;
    }
    .action-col {
      display: flex;
      align-items: center;
      .delete-icon {
        max-width: 22px;
        cursor: pointer;
        margin-left: 15px;
      }
    }
  }
  .table thead th {
    border-top: none;
    border-width: 1px;
    vertical-align: top;
  }
  /* p {
            border-radius: 4px;
          border: solid 1px #87cdf1;
          height: 40px;
          display: flex;
          align-items: center;
          padding: 0 14px;
          margin: 0;
          } */
  .edit-button {
    width: 167px;
    margin-top: 25px;
  }
  @media (max-width: 600px) {
    margin: 20px 0;
  }
`;

const EditPopup = styled.div`
  margin-right: 0;
  margin-left: auto;
  padding: 15px 15px 23px;
  border: solid 1px #87cdf1;
  margin-top: 25px;
  border-radius: 4px;
  position: absolute;
  width: 100%;
  max-width: 350px;
  background: #fff;
  right: 0;
  z-index: 1;
  .tax-exemption {
    margin: 25px 0;
  }
  .closeIcon {
    cursor: pointer;
  }
  /* @media (max-width: 900px) {
            max-width: 50%;

          }
          @media (max-width: 650px) {
            max-width: 100%;

          } */
`;

const EditPopupWrapper = styled.div``;
